<template>
  <div>
    <m-tabbar></m-tabbar>
    <div class="manage-style">
      <div class="topForm">
        <a-form id="add" :form="form" ref="formbook" layout="inline">
          <a-form-item label="年级">
            <a-select placeholder="请选择" style="width:100px" v-model="defaultName">
              <a-select-option
                v-for="(item, index) in stageList"
                :key="index"
                :value="item.name"
                @click="changeClass(item)"
              >{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="学科">
            <a-select placeholder="请选择" style="width:110px" v-model="form.subjectId">
              <a-select-option
                v-for="(item, index) in subjectsList"
                :key="index"
                :value="item.id"
                @click="changeSubjects(item)"
              >{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="时间">
            <!-- <a-button>本周</a-button>
                        <a-button>本月</a-button>
            <a-button>三个月</a-button>-->
            <a-range-picker
              style="width:225px"
              :allowClear="false"
              :placeholder="['开始时间', '结束时间']"
              :disabled-date="disabledDate"
              :defaultValue="[
                moment(
                  moment()
                    .subtract(7, 'days')
                    .calendar()
                ),
                moment(moment().subtract(1, 'days')),
              ]"
              @change="onChangeTime"
            />
          </a-form-item>
        </a-form>
      </div>
      <div v-if="!noData" class="analysisOnly">
        <div class="firstUl">
          <div class="leftDiv">
            <p class="stitle">平均得分率</p>
            <p class="ldetail">{{ (taskList.aveScore / 100) | parseFloat }}%</p>
            <div>
              <highcharts :options="optionAverage" ref="highcharts2" style="height: 320px;"></highcharts>
            </div>
          </div>
          <div class="rightDiv">
            <highcharts :options="aveScore" ref="highcharts"></highcharts>
          </div>
        </div>
        <div class="secondBox">
          <div class="leftTable">
            <p style="padding:20px">班级作业完成情况</p>
            <div class="tableUl flexSh">
              <p v-for="(item, index) in columnClass" :key="index">{{ item.title }}</p>
            </div>
            <div class="tabHeight flexSh">
              <div class="tableDetail" v-for="(item, index) in classData" :key="index">
                <div>
                  <p @click="classDetail(item)" style="cursor: pointer;">
                    <a-icon type="up" />
                  </p>
                  <p>{{ item.className }}</p>
                  <p>{{ item.exerciseNum }}</p>
                  <p>{{ item.quesNum }}</p>
                  <p>{{ item.delayRate | parseFloat }}</p>
                  <p>{{ item.submitRate | parseFloat }}%</p>
                  <p>{{ item.rightRate | parseFloat }}%</p>
                  <p>{{ item.aveScore | parseFloat }}%</p>
                  <p>{{ item.revisionRate | parseFloat }}%</p>
                </div>
                <div
                  v-show="item.showDetail"
                  v-for="(i, index) in item.exercisesDetail"
                  :key="index"
                >
                  <p></p>
                  <p></p>
                  <p>{{ i.name }}</p>
                  <p>{{ i.allQuesNum | parseFloat }}</p>
                  <p>{{ i.delayRate | parseFloat }}</p>
                  <p>{{ i.submitRate | parseFloat }}%</p>
                  <p>{{ i.rightRate | parseFloat }}%</p>
                  <p>{{ i.aveScore | parseFloat }}%</p>
                  <p>{{ i.revisionRate | parseFloat }}%</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="threeTable">
          <div>
            <p>老师作业情况</p>
            <div class="tableUl flexSh">
              <p v-for="(item, index) in columns" :key="index">{{ item.title }}</p>
            </div>
            <div class="tabHeight flexSh">
              <div class="tableDetail" v-for="(item, index) in teacherList" :key="index">
                <div>
                  <p @click="teacher(item)" style="cursor: pointer;">
                    <a-icon type="up" />
                  </p>
                  <p>{{ item.teacherName }}</p>
                  <p>{{ item.exerNum }}</p>
                  <p>{{ item.allQuesNum }}</p>
                  <p>{{ item.subjectiveCount }}</p>
                  <p>{{ item.correctRate | parseFloat }}%</p>
                  <p>{{ item.revisionCorrectRate | parseFloatMax }}%</p>
                  <p>{{ item.microLessonCount | parseFloat }}</p>
                  <p>{{ item.microPlayTime | ms2min }}</p>
                </div>
                <div
                  v-show="item.showDetail"
                  v-for="(i, index) in item.exercisesDetail"
                  :key="index"
                >
                  <p></p>
                  <p></p>
                  <p>{{ i.title }}</p>
                  <p>{{ i.questionCount }}</p>
                  <p>{{ i.subjectivecount }}</p>
                  <p>{{ i.correctRate | parseFloat }}%</p>
                  <p>{{ i.revisionCorrectRate | parseFloatMax }}%</p>
                  <p>{{ i.microLessonCount | parseFloat }}</p>
                  <p>{{ i.microLessconTime | ms2min }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="fourBox">
          <div class="progressLeft">
            <p>班级学科教学进度条</p>
            <div>暂无数据</div>
          </div>
          <div class="wordRight">
            <p>年级知识点掌握标签云</p>
            <div class="box">
              <highcharts :options="optionWord" ref="highcharts"></highcharts>
            </div>
          </div>
        </div>
        <div class="fiveTable">
          <div>
            <p>高频错题</p>
            <a-table
              :dataSource="wrongList"
              :rowKey="(record) => record.id"
              :locale="{ emptyText: '暂无数据' }"
            >
              <a-table-column title="题目短标题">
                <template slot-scope="record">
                  <span class="spanChange">
                    {{
                    record.data.questionStem.substring(0, 50)
                    }}
                  </span>
                </template>
              </a-table-column>
              <a-table-column title="来源">
                <template slot-scope="record">
                  <span>{{ record.data.title }}</span>
                </template>
              </a-table-column>
              <a-table-column title="题目难度系数">
                <template slot-scope="record">
                  <span>{{ record.data.experienceddifficulty }}</span>
                </template>
              </a-table-column>
              <a-table-column title="错题人数">
                <template slot-scope="record">
                  <span>{{ record.data.wrongNum }}</span>
                </template>
              </a-table-column>
            </a-table>
          </div>
        </div>
      </div>
      <div v-if="noData" class="noData" style="margin-top:100px;">
        <p>
          <img src="../../assets/images/noData.png" alt />
        </p>
      </div>
      <!-- 刷新 -->
      <div v-if="loadingList" style="position:fixed;margin-left:40%;top:55%;z-index:99;">
        <a-spin size="large" />
      </div>
    </div>
  </div>
</template>

<script>
import mTabbar from '../../../src/components/headTable'
import moment from 'moment'
import Highcharts from 'highcharts/highstock'
export default {
  data () {
    return {
      noData: false,
      loadingList: false,
      moment,
      stageList: [],
      defaultName: '',
      stageId: '',
      form: {
        subjectId: '',
        subjectName: '',
        startTime: moment()
          .subtract(7, 'days')
          .format('YYYY-MM-DD'),
        endTime: moment()
          .subtract(1, 'days')
          .format('YYYY-MM-DD'),
      },
      subjectsList: [],
      day: '',
      taskList: [],
      aveScore: {},
      classData: [],
      optionAverage: {},
      columnClass: [
        { title: '' },
        { title: '班级' },
        { title: '作业份数' },
        { title: '总题数' },
        { title: '延期交作业比例' },
        { title: '提交率' },
        { title: '完对率' },
        { title: '得分率' },
        { title: '订正率' },
      ],
      columns: [
        { title: '' },
        { title: '姓名' },
        { title: '作业份数' },
        { title: '总题数' },
        { title: '主观题' },
        { title: '批改率' },
        { title: '订正批改率' },
        { title: '微课录制数量' },
        { title: '微课总时长' },
      ],
      teacherList: [],
      optionWord: {},
      wrongList: [],
      pagination: {
        page: 1,
        pageSize: 9999,
      },
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    // 选择班级
    getGrade () {
      this.$http
        .get('v1/learnonly/teachingAssistant/getgrade', {
          params: { userid: this.$store.getters.id },
        })
        .then((response) => {
          if (response.data) {
            // response.data.data.unshift({
            //     id: '',
            //     name: '全部',
            // })
            this.stageList = response.data.data
            this.defaultName = response.data.data[0].name
            this.stageId = response.data.data[0].id
            this.$nextTick(() => {
              this.getAllselect()
            })
          }
        })
    },
    changeClass (item) {
      this.stageId = item.id
      this.$nextTick(() => {
        this.getAllselect()
      })
    },
    // 获取学科
    getAllselect () {
      this.$http
        .get('v1/learnonly/teachingAssistant/showGradeBank', {
          params: {
            userid: this.$store.getters.id,
          },
        })
        .then((response) => {
          if (response.data.code == 200) {
            var items = response.data.data
            for (let i = 0; i < items.length; i++) {
              if (this.stageId == items[i].gradeId) {
                this.subjectsList = items[i].subjects
              }
            }
            this.form.subjectId = this.subjectsList[0].id
            this.$nextTick(() => {
              this.getData()
              this.getWordData()
              this.getWrongData()
            })
          }
        })
    },
    changeSubjects (item) {
      this.form.subjectId = item.id
      this.$nextTick(() => {
        this.getData()
        this.getWordData()
        this.getWrongData()
      })
    },
    // 时间
    disabledDate (current) {
      return current && current > moment(new Date()).add(-1, 'days')
    },
    onChangeTime (date, dateString) {
      this.form.startTime = dateString[0]
      this.form.endTime = dateString[1]
      this.getData()
      this.getWordData()
      this.getWrongData()
    },
    // 获取学科数据
    getData () {
      this.$http
        .get('/v1/learnonly/aianalyse/master/grade/subject', {
          params: {
            orgid: this.$store.getters.orgid,
            gradeid: this.stageId,
            subjectid: this.form.subjectId,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
          },
        })
        .then((res) => {
          console.log(res)
          if (res.data.code == 200) {
            this.taskList = res.data.data
            // 平均得分率
            this.optionAverage = {
              chart: {
                type: 'solidgauge',
                height: 230,
                marginBottom: 50,
              },
              title: null,
              pane: {
                center: ['50%', '72%'],
                size: '100%',
                startAngle: -120,
                endAngle: 120,
                background: {
                  borderWidth: 0,
                  backgroundColor:
                    Highcharts.defaultOptions.legend.backgroundColor || 'red',
                  innerRadius: '75%',
                  outerRadius: '100%',
                  shape: 'arc',
                },
              },
              tooltip: {
                enabled: false,
              },
              yAxis: {
                min: 0,
                max: 100,
                stops: [
                  [0.1, '#55BF3B'], // green
                  [0.5, '#DDDF0D'], // yellow
                  [0.9, '#DF5353'], // red
                ],
                lineWidth: 0,
                minorTickInterval: null,
                tickPixelInterval: 400,
                tickLength: 0,
                title: {
                  y: -70,
                },
                labels: {
                  y: 16,
                },
              },

              plotOptions: {
                solidgauge: {
                  innerRadius: '75%',
                  dataLabels: {
                    y: -45,
                    borderWidth: 0,
                    useHTML: true,
                  },
                },
              },
              legend: {
                enabled: false, //  禁用图例
              },
              credits: {
                enabled: false,
              },
              series: [
                {
                  data: [
                    parseFloat(Number(res.data.data.aveScore / 100).toFixed(2)),
                  ],
                  dataLabels: {
                    format:
                      '<div style="text-align:center">' +
                      '<span style="font-size: 25px;white-space: nowrap;font-weight: bold;color: rgb(0, 0, 0);margin-left: 0px;margin-top: 0px;">' +
                      '<div class="solidguage-custom" style="transform:scale(0.668);-webkit-transform:scale(0.668);">' +
                      '<span class="solidgauge-percent">{y}</span>' +
                      '<div class="pa solidgauge-angle" style="background-color:#40A276;transform:rotate(123.5deg);-webkit-transform:rotate(123deg);">' +
                      // '<span class="solidgauge-angle-arrow" style="border-bottom-color:#40A276"></span>' +
                      '</div>' +
                      '</div>' +
                      '</span>' +
                      '</div>',
                  },
                },
              ],
            }
            // 得分率走势图
            var data = res.data.data.aveScoreMap
            var arrData = []
            var arrScore = []
            for (let [k, i] of Object.entries(data)) {
              if (k) arrData.push(k)
              if (i == 0) i = null
              arrScore.push(parseFloat(Number(i / 100).toFixed(2)))
            }
            this.aveScore = {
              chart: {
                type: 'spline',
                backgroundColor: '#24263e',
              },
              title: {
                text: '得分率走势图（%）',
                style: {
                  color: '#fff',
                },
              },
              legend: {
                enabled: false, //  禁用图例
              },
              credits: {
                enabled: false, //不显示LOGO
              },
              xAxis: {
                categories: arrData,
                labels: {
                  style: {
                    color: 'rgba(255,255,255,0.5)',
                  },
                },
              },
              yAxis: {
                title: {
                  text: '得分率',
                },
                labels: {
                  style: {
                    color: 'rgba(255,255,255,0.5)',
                    // fontSize: '14px',
                    // fontFamily: '微软雅黑'
                  },
                },
                max: 100,
              },
              series: [
                {
                  name: '完对率',
                  // color: "rgb(81, 130, 228)",
                  marker: {
                    symbol: 'square',
                  },
                  tooltip: {
                    valueSuffix: '%',
                  },
                  data: arrScore,
                },
              ],
            }
            // 班级作业完成情况
            this.classData = res.data.data.classDataMessages
            for (let i = 0; i < this.classData.length; i++) {
              this.classData[i].showDetail = false
            }
            console.log(this.classData)
            // 老师作业情况
            this.teacherList = res.data.data.teacherDataMessages
            for (let i = 0; i < this.teacherList.length; i++) {
              this.teacherList[i].showDetail = false
            }
          } else {
            this.taskList = []
          }
        })
    },
    // 获取班级作业完成情况
    classDetail (item) {
      this.$http
        .get('/v1/learnonly/aianalyse/master/grade/subject/class', {
          params: {
            orgid: this.$store.getters.orgid,
            gradeid: this.stageId,
            classid: item.classid,
            subjectid: this.form.subjectId,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            console.log(res)
            var items = res.data.data
            for (let i = 0; i < items.length; i++) {
              items.classid = item.classid
            }
            for (let j = 0; j < this.classData.length; j++) {
              if (item.classid == this.classData[j].classid) {
                this.classData[j].exercisesDetail = items
                this.classData[j].showDetail = !this.classData[j].showDetail
              } else {
                this.classData[j].showDetail = false
              }
            }
            this.$forceUpdate(this.classData)
          }
        })
    },
    // 获取老师作业情况
    teacher (item) {
      this.$http
        .get('/v1/learnonly/aianalyse/master/grade/subject/teacher', {
          params: {
            orgid: this.$store.getters.orgid,
            gradeid: this.stageId,
            teacherid: item.teacherid,
            subjectid: this.form.subjectId,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            page: this.pagination.page,
            size: this.pagination.pageSize,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            console.log(res)
            var items = res.data.data.exercises
            for (let j = 0; j < this.teacherList.length; j++) {
              if (item.teacherid == this.teacherList[j].teacherid) {
                this.teacherList[j].exercisesDetail = items
                this.teacherList[j].showDetail = !this.teacherList[j].showDetail
              } else {
                this.teacherList[j].showDetail = false
              }
            }
            this.$forceUpdate(this.teacherList)
          }
        })
    },
    // 知识点
    getWordData () {
      this.$http
        .get('/v1/learnonly/aianalyse/master/grade/subject/knowledge', {
          params: {
            orgid: this.$store.getters.orgid,
            gradeid: this.stageId,
            subjectid: this.form.subjectId,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
          },
        })
        .then((res) => {
          if (res.data) {
            // 年级知识点掌握标签云
            var cloudData = res.data.knowledge
            var cloudArr = []
            for (let i = 0; i < cloudData.length; i++) {
              cloudArr.push({
                name: cloudData[i].knowledgename,
                value: cloudData[i].writequescount,
              })
            }
            this.optionWord = {
              title: {
                text: '',
              },
              chart: {
                backgroundColor: '#24263e',
                type: 'wordcloud',
              },
              credits: {
                enabled: false, //不显示LOGO
              },
              series: [
                {
                  name: '测评次数',
                  data: cloudArr,
                },
              ],
            }
          }
        })
    },
    // 错题列表
    getWrongData () {
      this.$http
        .get('/v1/learnonly/aianalyse/master/grade/subject/wrongques', {
          params: {
            orgid: this.$store.getters.orgid,
            gradeid: this.stageId,
            subjectid: this.form.subjectId,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
          },
        })
        .then((res) => {
          // console.log("错题列表", res)
          if (res.data) {
            this.wrongList = res.data.wrongMessageMap
          } else {
            this.taskList = []
          }
        })
    },
  },
  components: {
    mTabbar,
  },
  filters: {
    // 保留两位小数去0
    parseFloat (num) {
      if (num == undefined) {
        return '0'
      } else {
        var val = parseFloat(num).toFixed(2)
        return parseFloat(val)
      }
    },
    parseFloatMax (num) {
      if (num == undefined) {
        return '0'
      } else {
        var val = parseFloat(num).toFixed(2)
        return val > 100 ? 100 : parseFloat(val)
      }
    },
    ms2min (ms) {
      if (ms) {
        var min = Math.floor((ms / 1000 / 60) << 0)
        var sec = Math.floor((ms / 1000) % 60)
        return min + '分' + sec + '秒'
      } else {
        return '/'
      }
    },
  },
  mounted () {
    this.getGrade()
    // 两日期间隔天数
    this.day =
      moment(this.form.endTime).diff(moment(this.form.startTime), 'days') +
      Number(1)
    // 本月多少天
    // const startDate = moment().daysInMonth()
  },
}
</script>

<style lang="scss">
@import '~@/assets/css/theme.scss';
</style>

<style scoped>
/* @import url('https://m1.bdp.cn/static/pkg/shareApp-bundle_74a0ab6.css'); */
/deep/ p {
  margin: 0;
  padding: 0;
}
.topForm {
  background: #fff;
  padding: 20px 0 0 0;
  border-bottom: 10px solid #eee;
  box-shadow: rgba(0, 0, 0, 0.25) 1px 1px 5px;
}
/deep/ .ant-form-inline .ant-form-item {
  display: inline-block;
  margin: 0 16px 20px 10px;
}
/* 1 */
.firstUl {
  background: #19192c;
  color: #fff;
  padding: 15px 15px 0 15px;
  overflow: hidden;
}
.firstUl .leftDiv {
  float: left;
  width: 30%;
  height: 400px;
  background: #24263e;
  border-right: 10px solid #19192c;
  padding: 20px;
}

.firstUl .rightDiv {
  float: left;
  width: 70%;
  height: 300px;
  background: #24263e;
}
/* 雷达图样式 */
/* /deep/.highcharts-root text {
    fill: rgba(255, 255, 255, 0.7) !important;
} */
/* 2 */
.secondBox {
  background: #19192c;
  padding: 15px 15px 0 15px;
  overflow: hidden;
}
.secondBox .leftTable {
  width: 100%;
  height: 400px;
  background: #24263e;
  /* border-right: 10px solid #19192c; */
}
.secondBox .leftTable p {
  color: rgba(255, 255, 255, 0.7);
  /* padding: 20px; */
}
.stitle {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}
.ldetail {
  font-size: 22px;
  color: #fff;
}
/* 得分率半扇型样式 */
/deep/.pa {
  position: absolute;
}
/deep/.solidgauge-angle {
  box-sizing: content-box;
  width: 65px;
  height: 65px;
  top: 8px;
  left: 7px;
  z-index: -1;
  border-radius: 50px;
  background-clip: padding-box;
}
/deep/.solidguage-custom {
  text-align: center;
  width: 80px;
  line-height: 40px;
  position: relative;
  z-index: 2;
}
/deep/.solidgauge-angle-arrow {
  content: '';
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 20px 20px;
  border-color: transparent;
  line-height: 0;
  position: absolute;
  top: -13px;
  left: 10px;
}
/deep/.solidgauge-percent {
  color: #fff;
  position: relative;
  top: 18px;
  font-size: 18px;
  font-weight: 600;
}
/deep/.highcharts-color-0 {
  fill: #40a276;
  stroke: #40a276;
}
/deep/.highcharts-pane {
  fill: #009966;
  fill-opacity: 0.3;
}
/* 表格样式 */
/deep/.ant-table-tbody > tr > td {
  border-bottom: 1px solid #313449;
  border-right: 1px solid #313449;
  color: rgb(225, 225, 225, 0.8);
  text-align: center;
  line-height: 32px;
  padding: 0;
}
/deep/.ant-table-tbody tr:hover > td {
  background: #24263e !important;
}
/deep/.ant-table-placeholder {
  background: #24263e;
  color: rgba(225, 225, 255, 0.7);
  border-bottom: none;
}
/deep/.ant-table-thead > tr > th {
  background: #24263e;
  color: rgba(255, 255, 255, 0.7);
  border-bottom: 1px solid #313449;
  border-top: 1px solid #313449;
  border-right: 1px solid #313449;
  text-align: center;
  line-height: 4px;
  padding: 16px 0px;
}
/deep/.ant-table-thead > tr:first-child > th:last-child {
  border-right: none;
}
/deep/.highcharts-grid-line {
  fill: none;
  stroke: none;
}
/* 3 */
.threeTable {
  background: #19192c;
  padding: 15px;
}
.threeTable > div {
  min-height: 400px;
  background: #24263e;
}
.threeTable > div > p {
  color: rgba(255, 255, 255, 0.7);
  padding: 20px;
}
.tableUl {
  display: flex;
  background: #191a2c;
}
.tableUl p {
  flex: 1;
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  line-height: 36px;
  padding: 0 5px;
  border-right: 1px solid #24263e;
  text-align: center;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.flexSh p:first-child {
  flex: 0.5;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.flexSh .tableDetail p:first-child {
  flex: 0.5;
}
.tabHeight {
  height: 300px;
  overflow: auto;
}
.dayHeight {
  height: 353px;
  overflow: auto;
}
/* 滚动条 */
::-webkit-scrollbar {
  width: 0;
}
.tableDetail div {
  display: flex;
  border-bottom: 1px solid #24263e;
  background: #313449;
}
.tableDetail p {
  flex: 1;
  font-size: 13px;
  line-height: 32px;
  padding: 0 5px;
  border-right: 1px solid #24263e;
  text-align: center;
  color: #fff;
}
h2 {
  font-size: 16px;
  margin: 10px;
  text-align: left;
  color: #fff;
}
/deep/.threeTable .ant-table-tbody > tr > td {
  background: #24263e;
  border-bottom: 1px solid #313449;
  border-right: 1px solid #313449;
  color: rgb(225, 225, 225, 0.8);
  text-align: center;
  padding: 16px 0;
}
/deep/.ant-table-row-expand-icon {
  background: none;
}
/* 4 */
.fourBox {
  background: #19192c;
  padding: 0 15px 15px 15px;
  overflow: hidden;
}
.fourBox .progressLeft {
  float: left;
  width: 50%;
  height: 454px;
  background: #24263e;
  border-right: 10px solid #19192c;
  padding: 20px;
  color: rgba(225, 225, 255, 0.7);
}
.fourBox .progressLeft > div {
  text-align: center;
  margin-top: 200px;
}
.fourBox .wordRight {
  float: left;
  width: 50%;
  background: #24263e;
  padding: 20px 20px 0;
}
.fourBox .wordRight > p {
  color: #fff;
  font-size: 16px;
  margin-bottom: 10px;
}
/* 5 */
.fiveTable {
  background: #19192c;
  padding: 0 15px 15px 15px;
}
.fiveTable > div {
  background: #24263e;
}
.fiveTable > div > p {
  color: rgba(255, 255, 255, 0.7);
  padding: 20px;
}
/* 修改基准线样式 */
/deep/.highcharts-plot-line {
  fill: none;
  stroke: #8fc2ec;
  stroke-width: 1px;
}
/* 修改分页样式 */
/deep/.ant-pagination-prev .ant-pagination-item-link,
/deep/.ant-pagination-next .ant-pagination-item-link {
  border: none;
  background-color: rgba(255, 255, 255, 0.3);
}
/deep/.ant-pagination-item {
  border: none;
  background-color: rgba(255, 255, 255, 0.3);
}
/deep/.ant-pagination-item a {
  color: rgb(255, 255, 255, 0.8);
}
/deep/.ant-pagination-item-active a {
  color: #1890ff;
}
/deep/.ant-pagination-jump-next
  .ant-pagination-item-container
  .ant-pagination-item-ellipsis {
  color: rgba(255, 255, 255, 0.5);
}
</style>
